module.exports = __webpack_public_path__ + "static/media/express.8ea43cac.eps";